module.exports = __webpack_public_path__ + "img/chip_500k.1b78be33.png";